import Vue from 'vue';
import { Lazyload } from 'vant';
import ClickEventWrapper from '@/components/ClickEventWrapper.vue';
import '@/assets/iconfont';
import SvgIcon from '@/components/SvgIcon.vue';
import ImageViewer from '@3vjia/v-img-viewer';
import {
  Swiper as SwiperClass, Pagination, Mousewheel, Autoplay,
} from 'swiper/swiper.esm';
// 瀑布流插件
import { VueMasonryPlugin } from 'vue-masonry';
// 注意这里路径，可以从node_modules/swiper查看文件位置
import javascriptBridge from './lib/javascript-bridge';

// Swiper modules
SwiperClass.use([Pagination, Mousewheel, Autoplay]);

// 注册全局组件
Vue.component(ClickEventWrapper.name, ClickEventWrapper);
Vue.component('svg-icon', SvgIcon);
Vue.use(VueMasonryPlugin);

// 使用Vue插件
Vue.use(Lazyload);
Vue.use(ImageViewer, {
  interceptor: (params) => {
    const { images, currentIndex } = params;
    // 兼容小于1.4.0
    if (javascriptBridge.device.swjApp) {
      // 调用原生的方法
      javascriptBridge.callHandler('previewImage', { images, currentIndex });
      return false;
    }
    return true;
  },
  options: {
    fontSize: '4vw',
  },
});
